// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"89":"curso","231":"feed","485":"rodape","534":"como-funciona","535":"login"}[chunkId] + "." + {"89":"18297f18","231":"3144f785","485":"0d100685","534":"51c8a2b7","535":"abc51d9c"}[chunkId] + ".js";
};